import isPlainObject from 'is-plain-object';
import { fromJS, Map, List, Record, Set } from 'immutable';
import React from 'react';
import classNames from 'classnames';
import Debug from 'debug';
import invariant from 'tiny-invariant';
import PropTypes from 'prop-types';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};











var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};



















var toConsumableArray = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  } else {
    return Array.from(arr);
  }
};

var Data = function () {
  function Data() {
    classCallCheck(this, Data);
  }

  createClass(Data, null, [{
    key: 'create',
    value: function create() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      if (Map.isMap(attrs)) {
        return attrs;
      }

      if (isPlainObject(attrs)) {
        return Data.fromJSON(attrs);
      }

      throw new Error('`Data.create` only accepts objects or maps, but you passed it: ' + attrs);
    }
  }]);
  return Data;
}();

Data.fromJSON = fromJS;
Data.fromJS = fromJS;

/*
 * Cells can be identified in two ways:
 *
 * 1. Using their x,y coordinates in the sheet. X and y are zero based, with
 *    x representing the column and y representing the row.
 * 2. Using their key. Each cell must have unique key string that is assigned by
 *    the application. If no key is assigned then the key will simply be an
 *    integer. Keys can be used to refer to cells even if they move, e.g.
 *    if columns are reordered, or if rows are expanded or collapsed. Keys
 *    must be consistent between multiple views of the same data, even across
 *    different users. This makes it possible to collaborate, even if different
 *    users have expended or collapsed rows of data.
 */

var DEFAULTS = {
  key: undefined, // Globally unique identifier of this cell.
  x: undefined, // zero based cell index on row.
  y: undefined, // zero based row index.
  data: undefined,
  editValue: undefined, // Value that user edits
  displayValue: undefined, // Value that user sees
  types: undefined,
  colspan: 1 // Width of the column.
};

var lastKey = 0;

var Cell = function (_Record) {
  inherits(Cell, _Record);

  function Cell() {
    classCallCheck(this, Cell);
    return possibleConstructorReturn(this, (Cell.__proto__ || Object.getPrototypeOf(Cell)).apply(this, arguments));
  }

  createClass(Cell, [{
    key: 'toJSON',
    value: function toJSON() {
      var object = {
        types: this.types.toJSON(),
        key: this.key,
        data: this.data.toJSON(),
        displayValue: this.displayValue,
        editValue: this.editValue,
        colspan: this.colspan
      };

      return object;
    }
  }, {
    key: 'isReadOnly',
    value: function isReadOnly() {
      return this.types.includes('header') || this.types.includes('readOnly');
    }
  }, {
    key: 'isSelectable',
    value: function isSelectable() {
      return !(this.types.includes('unselectable') || this.types.includes('header'));
    }
  }, {
    key: 'hasType',
    value: function hasType(type) {
      return this.types.includes(type);
    }
  }, {
    key: 'hasAnyType',
    value: function hasAnyType(types) {
      return this.types.some(function (r) {
        return types.includes(r);
      });
    }
  }, {
    key: 'width',
    get: function get$$1() {
      return this.colspan || 1;
    }
  }, {
    key: 'textValue',
    get: function get$$1() {
      return get(Cell.prototype.__proto__ || Object.getPrototypeOf(Cell.prototype), 'displayValue', this) || this.editValue;
    }
  }, {
    key: 'coordinates',
    get: function get$$1() {
      return [this.x, this.y];
    }
  }], [{
    key: 'create',
    value: function create() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      /* No supported in our version of immutable.
      if (Cell.isCell(attrs)) {
        return attrs
      }
      */

      if (typeof attrs === 'string') {
        attrs = { type: attrs };
      }

      if (isPlainObject(attrs)) {
        return Cell.fromJSON(attrs);
      }

      throw new Error('`Cell.create` only accepts objects, strings or cells, but you passed it: ' + attrs);
    }
  }, {
    key: 'createList',
    value: function createList() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (List.isList(attrs) || Array.isArray(attrs)) {
        var list = new List(attrs.map(Cell.create));
        return list;
      }

      throw new Error('`Cell.createList` only accepts arrays or lists, but you passed it: ' + attrs);
    }
  }, {
    key: 'fromJSON',
    value: function fromJSON(object) {
      /* No supported in our version of immutable.
      if (Cell.isCell(object)) {
        return object
      }
      */

      var _object$x = object.x,
          x = _object$x === undefined ? undefined : _object$x,
          _object$y = object.y,
          y = _object$y === undefined ? undefined : _object$y,
          _object$data = object.data,
          data = _object$data === undefined ? {} : _object$data,
          _object$editValue = object.editValue,
          editValue = _object$editValue === undefined ? undefined : _object$editValue,
          _object$displayValue = object.displayValue,
          displayValue = _object$displayValue === undefined ? undefined : _object$displayValue,
          _object$types = object.types,
          types = _object$types === undefined ? [] : _object$types,
          _object$key = object.key,
          key = _object$key === undefined ? undefined : _object$key,
          _object$colspan = object.colspan,
          colspan = _object$colspan === undefined ? 1 : _object$colspan;


      if ((typeof types === 'undefined' ? 'undefined' : _typeof(types)) !== 'object') {
        throw new Error('`Cell.fromJSON` requires a `types` array.');
      }

      if (!key) {
        // Allocate an arbitrary key
        key = '' + lastKey++;
      }

      var cell = new Cell({
        types: Set(types),
        data: Data.fromJSON(data),
        editValue: editValue,
        displayValue: displayValue,
        key: key,
        x: x,
        y: y,
        colspan: colspan
      });

      return cell;
    }
  }]);
  return Cell;
}(Record(DEFAULTS));

var DEFAULTS$1 = {
  key: undefined, // Globally unique identifier of this cell.
  y: undefined, // zero based row index.
  data: undefined,
  cells: undefined,
  types: undefined
};

var lastKey$1 = 0;

var Row = function (_Record) {
  inherits(Row, _Record);

  function Row() {
    classCallCheck(this, Row);
    return possibleConstructorReturn(this, (Row.__proto__ || Object.getPrototypeOf(Row)).apply(this, arguments));
  }

  createClass(Row, [{
    key: 'toJSON',
    value: function toJSON() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var object = {
        object: this.object,
        types: this.types.toJSON(),
        key: this.key,
        data: this.data.toJSON(),
        cells: this.cells.toArray().map(function (n) {
          return n.toJSON(options);
        })
      };

      return object;
    }
  }, {
    key: 'hasType',
    value: function hasType(type) {
      return this.types.includes(type);
    }
  }, {
    key: 'hasAnyType',
    value: function hasAnyType(types) {
      return this.types.some(function (r) {
        return types.includes(r);
      });
    }
  }], [{
    key: 'create',
    value: function create() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      /* No supported in our version of immutable.
      if (Row.isRow(attrs)) {
        return attrs
      }
      */

      if (typeof attrs === 'string') {
        attrs = { type: attrs };
      }

      if (isPlainObject(attrs)) {
        return Row.fromJSON(attrs);
      }

      throw new Error('`Row.create` only accepts objects, strings or rows, but you passed it: ' + attrs);
    }
  }, {
    key: 'createList',
    value: function createList() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (List.isList(attrs) || Array.isArray(attrs)) {
        var list = new List(attrs.map(Row.create));
        return list;
      }

      throw new Error('`Row.createList` only accepts arrays or lists, but you passed it: ' + attrs);
    }
  }, {
    key: 'fromJSON',
    value: function fromJSON(object) {
      /* No supported in our version of immutable.
      if (Row.isRow(object)) {
        return object
      }
      */

      var _object$data = object.data,
          data = _object$data === undefined ? {} : _object$data,
          _object$cells = object.cells,
          cells = _object$cells === undefined ? [] : _object$cells,
          _object$types = object.types,
          types = _object$types === undefined ? [] : _object$types,
          _object$key = object.key,
          key = _object$key === undefined ? undefined : _object$key,
          _object$y = object.y,
          y = _object$y === undefined ? undefined : _object$y;


      if ((typeof types === 'undefined' ? 'undefined' : _typeof(types)) !== 'object') {
        throw new Error('`Row.fromJSON` requires a `types` array.');
      }

      if (typeof key === 'undefined') {
        // Allocate an arbitrary key
        key = '' + lastKey$1++;
      }

      var row = new Row({
        y: y,
        types: Set(types),
        key: key,
        data: Data.fromJSON(data),
        cells: Cell.createList(cells)
      });

      return row;
    }
  }]);
  return Row;
}(Record(DEFAULTS$1));

var DEFAULTS$2 = {
  data: undefined,
  rows: undefined,
  focused: false // Whether some aspect of the sheet is focused
};

var Sheet = function (_Record) {
  inherits(Sheet, _Record);

  function Sheet() {
    classCallCheck(this, Sheet);
    return possibleConstructorReturn(this, (Sheet.__proto__ || Object.getPrototypeOf(Sheet)).apply(this, arguments));
  }

  createClass(Sheet, [{
    key: 'toJSON',
    value: function toJSON() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var object = {
        data: this.data.toJSON(),
        rows: this.rows.toArray().map(function (n) {
          return n.toJSON(options);
        }),
        focused: this.focused
      };

      return object;
    }
  }, {
    key: 'rowCount',
    value: function rowCount() {
      return this.rows.size;
    }
  }, {
    key: 'columnCount',
    value: function columnCount() {
      var maxColumns = 0;
      this.rows.forEach(function (row) {
        if (row.cells.size > maxColumns) {
          maxColumns = row.cells.size;
        }
      });
      return maxColumns;
    }
  }, {
    key: 'lookupCellByKey',
    value: function lookupCellByKey(key) {
      var cell = this.findCell(function (cell) {
        return cell.key === key;
      });
      if (!cell) {
        throw new Error('No cell found for key \'' + key + '\'');
      }
      return cell;
    }

    // TODO: This seems inefficient. Using an object to do hash lookup by key
    // would be better ... but I don't know how to achieve two references to
    // the same object in immutable.

  }, {
    key: 'findCell',
    value: function findCell(matcher) {
      var cell = null;
      this.rows.find(function (row) {
        cell = row.cells.find(matcher);
        return cell != null;
      });
      return cell;
    }

    // TODO: See above.

  }, {
    key: 'filterCells',
    value: function filterCells(matcher) {
      var _List;

      var rowCells = this.rows.map(function (row) {
        return row.cells.filter(matcher);
      });
      return (_List = List([])).concat.apply(_List, toConsumableArray(rowCells));
    }
  }, {
    key: 'findRow',
    value: function findRow(matcher) {
      return this.rows.find(matcher);
    }
  }, {
    key: 'filterRows',
    value: function filterRows(matcher) {
      return this.rows.filter(matcher);
    }
  }, {
    key: 'lookupRowByKey',
    value: function lookupRowByKey(key) {
      var row = this.rows.find(function (row) {
        return row.key === key;
      });
      if (!row) {
        throw new Error('No row found for key ' + key);
      }
      return row;
    }
  }, {
    key: 'forEachCell',
    value: function forEachCell(fn) {
      this.rows.forEach(function (row) {
        row.cells.forEach(function (cell) {
          fn(cell);
        });
      });
    }
  }, {
    key: 'forEachRow',
    value: function forEachRow(fn) {
      this.rows.forEach(function (row) {
        fn(row);
      });
    }
  }], [{
    key: 'create',
    value: function create() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      /* No supported in our version of immutable.
        if (Sheet.isSheet(attrs)) {
          return attrs
        }
      */

      if (List.isList(attrs) || Array.isArray(attrs)) {
        attrs = { rows: attrs };
      }

      if (isPlainObject(attrs)) {
        return Sheet.fromJSON(attrs);
      }

      throw new Error('`Sheet.create` only accepts objects, arrays, lists or sheets, but you passed it: ' + attrs);
    }
  }, {
    key: 'fromJSON',
    value: function fromJSON(object) {
      /* No supported in our version of immutable.
      if (Sheet.isSheet(object)) {
        return object
      }
      */

      var _object$data = object.data,
          data = _object$data === undefined ? {} : _object$data,
          _object$rows = object.rows,
          rows = _object$rows === undefined ? [] : _object$rows,
          _object$focused = object.focused,
          focused = _object$focused === undefined ? false : _object$focused;


      var sheet = new Sheet({
        data: Data.fromJSON(data),
        rows: Row.createList(rows),
        focused: focused
      });

      return Sheet.populateXY(sheet);
    }

    // Populate each cell with its x,y coordinates in the sheet

  }, {
    key: 'populateXY',
    value: function populateXY(sheet) {
      sheet.rows.forEach(function (row, y) {
        var xOffset = 0;
        row.cells.forEach(function (cell, x) {
          sheet = sheet.updateIn(['rows', y, 'cells', x], function (cell) {
            return cell.set('x', x + xOffset).set('y', y);
          }).updateIn(['rows', y], function (row) {
            return row.set('y', y);
          });
          xOffset += cell.width - 1;
        });
      });
      return sheet;
    }
  }]);
  return Sheet;
}(Record(DEFAULTS$2));

var DEFAULTS$3 = {
  // focus and selection will be the same if only a single cell is selected.

  // The cell which is focused (where editing will occur).
  focusX: undefined,
  focusY: undefined,

  // The cell that defines the other extreme of the selection rectangle.
  selectionX: undefined,
  selectionY: undefined
};

// Use a constant so that React.shallowEqual compares props as equal.
var emptyArray = [];

var Selection = function (_Record) {
  inherits(Selection, _Record);

  function Selection() {
    classCallCheck(this, Selection);
    return possibleConstructorReturn(this, (Selection.__proto__ || Object.getPrototypeOf(Selection)).apply(this, arguments));
  }

  createClass(Selection, [{
    key: 'isCellSelected',
    value: function isCellSelected(controller, cell) {
      var ex = this.extents(controller);

      if (!cell || !cell.isSelectable()) {
        return false;
      }

      return cell.x >= ex.minX && cell.y >= ex.minY && cell.x + cell.width <= ex.maxX + 1 && cell.y <= ex.maxY;
    }

    // Return array of sides of selection that cell participates in. Also takes
    // into account adjacent unselectable cells.

  }, {
    key: 'selectionSide',
    value: function selectionSide(controller, cell) {
      if (!this.isCellSelected(controller, cell)) {
        return emptyArray;
      }
      var ex = this.extents(controller);
      var side = [];

      if (cell.y === ex.minY) {
        side.push('top');
      }
      if (cell.y === ex.maxY) {
        side.push('bottom');
      }
      if (cell.x === ex.minX) {
        side.push('left');
      }
      if (cell.x + cell.width - 1 === ex.maxX) {
        side.push('right');
      }

      // Consider adjacent cells.
      var acell = void 0;
      if ((acell = controller.getCellByXY(cell.x - 1, cell.y)) && !acell.isSelectable()) {
        side.push('left');
      }
      if ((acell = controller.getCellByXY(cell.x + 1, cell.y)) && !acell.isSelectable()) {
        side.push('right');
      }
      if ((acell = controller.getCellByXY(cell.x, cell.y - 1)) && !acell.isSelectable()) {
        side.push('top');
      }
      if ((acell = controller.getCellByXY(cell.x, cell.y + 1)) && !acell.isSelectable()) {
        side.push('bottom');
      }

      return side;
    }
  }, {
    key: 'isCellFocused',
    value: function isCellFocused(cell) {
      return this.focusX >= cell.x && this.focusX <= cell.x + cell.width - 1 && cell.y === this.focusY;
    }
  }, {
    key: 'extents',
    value: function extents(controller) {
      var minX = Math.min(this.focusX, this.selectionX);
      var minY = Math.min(this.focusY, this.selectionY);
      var maxX = Math.max(this.focusX, this.selectionX);
      var maxY = Math.max(this.focusY, this.selectionY);

      // Ensure selection extents are consistent with multi-column cells.
      // The selection must fully contain any multi-column cell that is included.
      // This will potentially expand the selection. Each time the selection is
      // expanded we need to consider expanding it again, e.g. if multi-column
      // cells are staggered.
      var growing = void 0;
      do {
        growing = false;
        for (var y = minY; y <= maxY; y++) {
          var leftCell = controller.getCellByXY(minX, y);
          var rightCell = controller.getCellByXY(maxX, y);

          if (leftCell.isSelectable() && leftCell.x < minX) {
            minX = leftCell.x;
            growing = true;
          }
          if (rightCell.isSelectable() && rightCell.x + rightCell.width - 1 > maxX) {
            maxX = rightCell.x + rightCell.width - 1;
            growing = true;
          }
        }
      } while (growing);

      return { minX: minX, minY: minY, maxX: maxX, maxY: maxY };
    }
  }]);
  return Selection;
}(Record(DEFAULTS$3));

var DEFAULTS$4 = {
  data: undefined,
  sheet: undefined,
  selection: undefined,
  editingX: undefined,
  editingY: undefined
};

var Value = function (_Record) {
  inherits(Value, _Record);

  function Value() {
    classCallCheck(this, Value);
    return possibleConstructorReturn(this, (Value.__proto__ || Object.getPrototypeOf(Value)).apply(this, arguments));
  }

  createClass(Value, [{
    key: 'toJSON',
    value: function toJSON() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var object = {
        object: this.object,
        sheet: this.sheet.toJSON(options)
      };

      if (options.preserveData) {
        object.data = this.data.toJSON(options);
      }

      if (options.preserveSelection) {
        object.selection = this.selection.toJSON(options);
      }

      return object;
    }
  }, {
    key: 'isCellEditing',
    value: function isCellEditing(cell) {
      return cell.x === this.editingX && cell.y === this.editingY;
    }
  }, {
    key: 'updateCell',
    value: function updateCell(cell, updater) {
      // Find the index of the cell so we can update it in place.
      var index = this.getIn(['sheet', 'rows', cell.y, 'cells']).findIndex(function (aCell) {
        return aCell.key === cell.key;
      });

      if (index === -1) {
        return this;
      }

      return this.updateIn(['sheet', 'rows', cell.y, 'cells', index], updater);
    }
  }], [{
    key: 'create',
    value: function create() {
      var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      /* No supported in our version of immutable.
      if (Value.isValue(attrs)) {
        return attrs
      }
      */

      if (isPlainObject(attrs)) {
        return Value.fromJSON(attrs, options);
      }

      throw new Error('`Value.create` only accepts objects or values, but you passed it: ' + attrs);
    }
  }, {
    key: 'fromJSON',
    value: function fromJSON(object) {
      var _object$data = object.data,
          data = _object$data === undefined ? {} : _object$data,
          _object$sheet = object.sheet,
          sheet = _object$sheet === undefined ? {} : _object$sheet,
          _object$selection = object.selection,
          selection = _object$selection === undefined ? {} : _object$selection;

      data = Data.fromJSON(data);
      sheet = Sheet.fromJSON(sheet);
      selection = new Selection();

      var value = new Value({
        data: data,
        sheet: sheet,
        selection: selection
      });

      return value;
    }
  }]);
  return Value;
}(Record(DEFAULTS$4));

/*
 * Default rendering behavior using HTML <table>.
 */
function RenderPlugin() {
  return {
    onRenderSheet: function onRenderSheet(props, controller, next) {
      var children = props.children;


      return React.createElement(
        'table',
        null,
        React.createElement(
          'tbody',
          null,
          children
        )
      );
    },
    onRenderRow: function onRenderRow(props, controller, next) {
      var row = props.row,
          children = props.children;

      var typeClasses = classNames(row.types.toArray().map(function (type) {
        return 'aha-sheet-type-' + type;
      }));

      return React.createElement(
        'tr',
        { className: typeClasses },
        children
      );
    },
    onRenderCell: function onRenderCell(props, controller, next) {
      var cell = props.cell,
          handlers = props.handlers,
          selected = props.selected,
          selectedSide = props.selectedSide,
          focused = props.focused,
          children = props.children,
          cellRef = props.cellRef;

      var selectedSideClass = selectedSide.map(function (side) {
        return defineProperty({}, 'selected-side-' + side, selected);
      });

      var typeClasses = cell.types.toArray().map(function (type) {
        return 'aha-sheet-type-' + type;
      });
      var cellClasses = classNames('aha-sheet-cell', typeClasses, selectedSideClass, {
        selected: selected,
        focused: focused,
        'aha-sheet-cell-empty': !cell.textValue
      });

      var spans = {};
      if (cell.colspan) {
        spans.colSpan = cell.colspan;
      }
      return React.createElement(
        'td',
        _extends({}, handlers, spans, { className: cellClasses, ref: cellRef }),
        children
      );
    },
    onRenderCellContent: function onRenderCellContent(props, controller, next) {
      var cell = props.cell;

      return React.createElement(
        'div',
        { className: 'aha-sheet-cell-content' },
        cell.textValue
      );
    }
  };
}

/*
 * Default behavior for handling selection cell with the cursor or mouse.
 */
function SelectionPlugin() {
  var selecting = false;

  var stopSelecting = function stopSelecting() {
    selecting = false;
  };

  return {
    onMouseDown: function onMouseDown(event, cell, controller, next) {
      if (!cell.isSelectable()) {
        return next();
      }

      if (event.shiftKey) {
        controller.selectToCell(cell);
      } else {
        controller.selectCell(cell);
      }

      selecting = true;

      // Register document level mouseup handler to catch mouseup outside element.
      document.addEventListener('mouseup', stopSelecting);

      return next();
    },
    onMouseUp: function onMouseUp(event, cell, controller, next) {
      stopSelecting();
      document.removeEventListener('mouseup', stopSelecting);

      return next();
    },
    onMouseMove: function onMouseMove(event, cell, controller, next) {
      if (selecting && cell.isSelectable()) {
        controller.selectToCell(cell);
      }

      return next();
    },
    onKeyDown: function onKeyDown(event, controller, next) {
      var expandSelection = event.shiftKey;

      if (!controller.isSheetFocused()) {
        return next();
      }

      switch (event.key) {
        case 'ArrowDown':
          controller.selectDown(expandSelection);
          break;
        case 'ArrowUp':
          controller.selectUp(expandSelection);
          break;
        case 'ArrowRight':
          controller.selectRight(expandSelection);
          break;
        case 'ArrowLeft':
          controller.selectLeft(expandSelection);
          break;
        case 'Tab':
          if (event.shiftKey) {
            controller.selectLeft(false, true);
          } else {
            controller.selectRight(false, true);
          }
          event.preventDefault(); // Don't tab to next element on page.
          break;
        case 'Enter':
          if (event.shiftKey) {
            controller.selectUp(false);
          } else {
            controller.selectDown(false);
          }
          break;
        default:
          return next();
      }
    },


    commands: {
      // Remove the selection.
      clearSelection: function clearSelection(controller) {
        controller.update(controller.value.setIn(['selection', 'focusX'], undefined).setIn(['selection', 'focusY'], undefined).setIn(['selection', 'selectionX'], undefined).setIn(['selection', 'selectionY'], undefined));
      },


      // Update the selection to a single cell.
      selectCell: function selectCell(controller, cell) {
        controller.selectXY(cell.x, cell.y);
      },


      // Return the currently focused cell
      focusedCell: function focusedCell(controller) {
        var x = controller.value.selection.focusX;
        var y = controller.value.selection.focusY;

        if (x === undefined || y === undefined) {
          return null;
        } else {
          return controller.getCellByXY(x, y);
        }
      },


      // Select a range of cells from the current focus cell to the new cell.
      selectToCell: function selectToCell(controller, cell) {
        controller.update(controller.value.setIn(['selection', 'selectionX'], cell.x).setIn(['selection', 'selectionY'], cell.y));
      },
      selectRange: function selectRange(controller, minX, minY, maxX, maxY) {
        controller.update(controller.value.setIn(['selection', 'focusX'], minX).setIn(['selection', 'focusY'], minY).setIn(['selection', 'selectionX'], maxX).setIn(['selection', 'selectionY'], maxY));
      },
      selectXY: function selectXY(controller, x, y) {
        var cell = controller.getCellByXY(x, y);
        if (cell) {
          controller.run('onSelectCell', { cell: cell });
        }

        controller.update(controller.value.setIn(['selection', 'focusX'], x).setIn(['selection', 'focusY'], y).setIn(['selection', 'selectionX'], x).setIn(['selection', 'selectionY'], y));
      },


      // Move selection in a particular direction. Automatically steps over
      // header cells and handles cells spanning multiple columns.
      selectOffset: function selectOffset(controller, offsetX, offsetY, expand) {
        var wrap = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

        var startX = void 0,
            startY = void 0;

        if (expand) {
          startX = controller.value.selection.selectionX;
          startY = controller.value.selection.selectionY;
        } else {
          startX = controller.value.selection.focusX;
          startY = controller.value.selection.focusY;
        }

        var cell = null;
        var x = startX + offsetX;
        var y = startY + offsetY;
        var maxX = controller.value.sheet.columnCount();
        var maxY = controller.value.sheet.rowCount();
        do {
          while ((cell = controller.getCellByXY(x, y)) && !cell.isSelectable() || !cell && y < maxY && y > 0 && x < maxX && x > 0) {
            x += offsetX;
            y += offsetY;
          }
          if (cell && cell.isSelectable() || !wrap) {
            break;
          }

          // See if we can wrap to another line.
          if (offsetX === 1 && y < maxY) {
            y += 1;
            x = 0;
          } else if (offsetX === -1 && y > 0) {
            y -= 1;
            x = maxX - 1;
          } else {
            break;
          }
        } while (true);

        if (cell && cell.isSelectable()) {
          if (expand) {
            controller.selectToCell(cell);
          } else {
            controller.selectXY(x, y);
          }
        }
      },


      // Move selection, potentially expanding or contracting it, and optionally
      // wrapping to the next/previous line.
      selectLeft: function selectLeft(controller, expand) {
        var wrap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        controller.selectOffset(-1, 0, expand, wrap);
      },
      selectRight: function selectRight(controller, expand) {
        var wrap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        controller.selectOffset(1, 0, expand, wrap);
      },
      selectUp: function selectUp(controller, expand) {
        controller.selectOffset(0, -1, expand);
      },
      selectDown: function selectDown(controller, expand) {
        controller.selectOffset(0, 1, expand);
      },
      cellsInSelection: function cellsInSelection(controller, iterator) {
        var extents = controller.value.selection.extents(controller);

        for (var y = extents.minY; y <= extents.maxY; y++) {
          for (var x = extents.minX; x <= extents.maxX; x++) {
            var cell = controller.value.getIn(['sheet', 'rows', y, 'cells', x]);
            if (cell) {
              iterator(cell);
            }
          }
        }
      }
    }
  };
}

var Input = function (_React$Component) {
  inherits(Input, _React$Component);

  function Input(props) {
    classCallCheck(this, Input);

    var _this = possibleConstructorReturn(this, (Input.__proto__ || Object.getPrototypeOf(Input)).call(this, props));

    _this.handleChange = function (event) {
      _this.setState({ value: event.target.textContent });
    };

    _this.handleBlur = function (event) {
      // Handle a click outside the component, but doesn't get called for clicks
      // on another cell.
      _this.props.controller.opSetCellContent(_this.props.cell, 'editValue', _this.state.value);
      _this.props.controller.endEditing();
      _this.savedState = true;
    };

    _this.handleKeyDown = function (event) {
      var controller = _this.props.controller;

      switch (event.key) {
        case 'Enter':
          _this.endAndSave();
          controller.selectDown(false);
          break;
        case 'Tab':
          _this.endAndSave();
          if (event.shiftKey) {
            controller.selectLeft(false, true);
          } else {
            controller.selectRight(false, true);
          }
          break;
        case 'ArrowUp':
          _this.endAndSave();
          controller.selectUp(false);
          break;
        case 'ArrowDown':
          _this.endAndSave();
          controller.selectDown(false);
          break;
        case 'Escape':
          // Setting state directly here is intentional so that it is set when
          // componentWillUnmount() is called. Using setState() is not reflected
          // by the time the component is unmounted.
          _this.state.value = _this.props.cell.editValue;
          controller.endEditing();
          controller.focusSheet();
          break;
      }
      event.stopPropagation();
    };

    var cell = props.cell;
    _this.state = { value: cell.editValue };
    _this.element = React.createRef();
    return _this;
  }

  createClass(Input, [{
    key: 'saveValue',
    value: function saveValue() {
      var _this2 = this;

      var sanitizedValue = this.props.controller.run('onSanitizeCell', this.state.value, this.props.cell, function () {
        return _this2.state.value;
      });
      this.props.controller.run('onSetCellContent', this.props.cell, 'editValue', sanitizedValue);
    }
  }, {
    key: 'endAndSave',
    value: function endAndSave() {
      var controller = this.props.controller;
      this.saveValue();
      controller.endEditing();
      controller.focusSheet();
      this.savedState = true;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.savedState = false;
      this.element.current.showPopover();
      this.element.current.focus();
      this.element.current.innerText = this.state.value;
      document.execCommand('selectAll', false, null);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      // Save current value when there was a click on another cell - we don't
      // get another other notification that editing is ending.
      if (!this.savedState) {
        this.saveValue();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var cellRef = this.props.cellRef;
      var sheetRef = this.props.sheetRef;
      var cellBounds = cellRef.current.getBoundingClientRect();
      var sheetBounds = sheetRef.current.getBoundingClientRect();
      var cellStyles = getComputedStyle(cellRef.current);
      var inputStyle = {
        left: cellBounds.left + window.scrollX,
        top: cellBounds.top + window.scrollY - 1,
        minWidth: cellBounds.width - 4, // To prevent overwriting the selection rectangle.
        minHeight: cellBounds.height - 3, // To make sure we cover the old value.
        // To allow expansion for larger input vales up to the size of the sheet.
        maxWidth: sheetBounds.width - (cellBounds.left - sheetBounds.left) - 4,
        maxHeight: sheetBounds.height - (cellBounds.top - sheetBounds.top) - 4,

        fontFamily: cellStyles.getPropertyValue('font-family'),
        fontSize: cellStyles.getPropertyValue('font-size'),
        lineHeight: cellStyles.getPropertyValue('line-height'),
        color: cellStyles.getPropertyValue('color'),
        textAlign: cellStyles.getPropertyValue('text-align')
      };

      var input = React.createElement('div', {
        key: this.props.cell.key,
        className: 'aha-sheet-input',
        contentEditable: 'true',
        ref: this.element,
        onBlur: this.handleBlur,
        onInput: this.handleChange,
        onKeyDown: this.handleKeyDown,
        style: inputStyle,
        onCopy: function onCopy(e) {
          return e.stopPropagation();
        },
        onPaste: function onPaste(e) {
          return e.stopPropagation();
        },
        suppressContentEditableWarning: true,
        popover: 'manual'
      });

      return [this.props.cell.textValue, input];
    }
  }]);
  return Input;
}(React.Component);

/*
 * Default behavior editing a cell.
 */


function InputPlugin() {
  var endEditing = function endEditing(controller, cell) {
    controller.endEditing();
  };

  var specialKey = function specialKey(event) {
    var keyCode = event.keyCode;


    return event.altKey || event.ctrlKey || event.metaKey ||
    // all control keys
    keyCode < 48 ||
    // meta keys
    keyCode > 90 && keyCode < 96 ||
    // F1 and F3+ keys, other non-printable keys
    keyCode === 112 || keyCode > 113 && keyCode < 146
    // F2 is intentionally allowed to enter edit mode, as it's a common shortcut in Excel and other programs
    ;
  };

  return {
    onDoubleClick: function onDoubleClick(event, cell, controller, next) {
      if (controller.canEditCell(cell)) {
        controller.startEditing(cell);
      } else {
        return next();
      }
    },
    onMouseDown: function onMouseDown(event, cell, controller, next) {
      // If we are editing, then clicking on another cell stops editing.
      if (!controller.isCellEditing(cell)) {
        endEditing(controller, cell);
      }

      return next();
    },
    onKeyDown: function onKeyDown(event, controller, next) {
      var cell = controller.focusedCell();

      // If there are no modifiers we start editing the focused cell immediately
      if (cell && controller.canEditCell(cell) && !controller.isCellEditing(cell)) {
        // Handle deleting the content.
        if (['Backspace', 'Delete'].includes(event.key)) {
          controller.run('onClearSelectedCells');

          return;
        } else if (!specialKey(event)) {
          controller.startEditing(cell);
        }

        return next();
      } else {
        return next();
      }
    },
    onRenderCellContent: function onRenderCellContent(props, controller, next) {
      var cell = props.cell,
          editing = props.editing,
          cellRef = props.cellRef,
          sheetRef = props.sheetRef;

      if (!editing) {
        return next();
      }

      return React.createElement(Input, {
        cell: cell,
        controller: controller,
        cellRef: cellRef,
        sheetRef: sheetRef
      });
    },


    commands: {
      focusSheet: function focusSheet(controller) {
        // Ensure the sheet is focused after input loses focus.
        setTimeout(function () {
          controller.onFocusSheet();
        });
      },
      blurSheet: function blurSheet(controller) {
        setTimeout(function () {
          controller.onBlurSheet();
        });
      }
    }
  };
}

var debug = Debug('aha-sheet:clipboard');

/*
 * Clipboard behavior.
 */
function ClipboardPlugin() {
  var parseClipboard = function parseClipboard(str) {
    return str.split(/\r\n|\n|\r/).map(function (row) {
      return row.split('\t');
    });
  };

  var copyCommon = function copyCommon(event, controller) {
    var text = '';
    var lastX = void 0;
    var lastY = void 0;

    controller.cellsInSelection(function (cell) {
      if (lastX !== undefined && cell.y === lastY) {
        text += '\t';
      } else if (lastY !== undefined && cell.y !== lastY) {
        text += '\n';
      }
      text += cell.textValue;

      lastX = cell.x;
      lastY = cell.y;
    });
    debug('Copied: ' + text);
    event.clipboardData.setData('text/plain', text);
    event.preventDefault();
  };

  return {
    onCopy: function onCopy(event, controller, next) {
      copyCommon(event, controller);
    },
    onCut: function onCut(event, controller, next) {
      copyCommon(event, controller);
      controller.opClearCellsInSelection();
    },
    onPaste: function onPaste(event, controller, next) {
      if (!controller.canEdit()) {
        return next();
      }

      var text = event.clipboardData.getData('text/plain');

      debug('Pasted: ' + text);
      event.preventDefault();

      var extents = controller.value.selection.extents(controller);
      var x = extents.minX;
      var y = extents.minY;
      var maxX = 0;
      var maxY = 0;
      var edits = [];
      parseClipboard(text).map(function (row, yOffset) {
        row.map(function (cellValue, xOffset) {
          var cell = controller.getCellByXY(x + xOffset, y + yOffset);
          if (cell && controller.canEditCell(cell)) {
            var sanitizedValue = controller.run('onSanitizeCell', cellValue, cell, function () {
              return cellValue;
            });
            edits.push({
              key: cell.key,
              from: cell.editValue,
              to: sanitizedValue
            });
            maxX = x + xOffset;
            maxY = y + yOffset;
          }
        });
      });

      controller.run('onEditCells', 'editValue', edits);

      // Select the pasted data.
      controller.selectRange(x, y, maxX, maxY);
    }
  };
}

/*
 * Read-only headers.
 */
function HeaderPlugin() {
  return {
    onRenderCell: function onRenderCell(props, controller, next) {
      var cell = props.cell,
          handlers = props.handlers;

      if (!cell.hasType('header')) {
        return next();
      }

      var typeClasses = classNames(cell.types.toArray().map(function (type) {
        return 'aha-sheet-type-' + type;
      }));
      var spans = {};
      if (cell.colspan) {
        spans.colSpan = cell.colspan;
      }

      return React.createElement(
        'th',
        _extends({}, handlers, spans, { className: typeClasses }),
        cell.textValue
      );
    }
  };
}

/*
 * Serializable operations.
 *
 * User initiated actions that can be undone or sent to other sheet instances
 * for collaboration.
 */

var Operation = function Operation(operation) {
  classCallCheck(this, Operation);

  this.operation = operation;
  this.data = {};
};

// Edits to cell content
//
// `data` is an array of {key: , from: , to: } structures describing the edits


var OperationCellEdits = function (_Operation) {
  inherits(OperationCellEdits, _Operation);

  function OperationCellEdits(property, edits) {
    classCallCheck(this, OperationCellEdits);

    var _this = possibleConstructorReturn(this, (OperationCellEdits.__proto__ || Object.getPrototypeOf(OperationCellEdits)).call(this, 'CellEdits'));

    _this.property = property;
    _this.data = edits;
    return _this;
  }

  createClass(OperationCellEdits, [{
    key: 'apply',
    value: function apply(controller) {
      var _this2 = this;

      this.data.forEach(function (edit) {
        var key = edit.key,
            to = edit.to;

        controller.updateCellByKey(key, _this2.property, to);
      });
    }
  }, {
    key: 'invert',
    value: function invert() {
      return new OperationCellEdits(this.property, this.data.map(function (edit) {
        return { key: edit.key, from: edit.to, to: edit.from };
      }));
    }
  }]);
  return OperationCellEdits;
}(Operation);

// Delete a row


var OperationDeleteRows = function (_Operation2) {
  inherits(OperationDeleteRows, _Operation2);

  function OperationDeleteRows(rowKeys) {
    classCallCheck(this, OperationDeleteRows);

    var _this3 = possibleConstructorReturn(this, (OperationDeleteRows.__proto__ || Object.getPrototypeOf(OperationDeleteRows)).call(this, 'DeleteRows'));

    _this3.rowKeys = rowKeys;
    return _this3;
  }

  createClass(OperationDeleteRows, [{
    key: 'apply',
    value: function apply(controller) {
      var _this4 = this;

      // Save the row data for restore.
      this.deletedRowsData = [];
      this.deletedRowIndex = null;
      this.rowKeys.forEach(function (rowKey) {
        var row = controller.getRowByKey(rowKey);
        _this4.deletedRowsData.push(row.toJSON());
        if (_this4.deletedRowIndex === null) {
          _this4.deletedRowIndex = row.y;
        }
      });

      // Remove the rows.
      controller.update(controller.value.updateIn(['sheet', 'rows'], function (rows) {
        return rows.splice(_this4.deletedRowIndex, _this4.deletedRowsData.length);
      }).update('sheet', function (sheet) {
        return Sheet.populateXY(sheet);
      }));

      controller.run('onRowsDeleted', this.deletedRowsData, this.deletedRowIndex);
    }
  }, {
    key: 'invert',
    value: function invert() {
      return new OperationCreateRows(this.deletedRowIndex, this.deletedRowsData);
    }
  }]);
  return OperationDeleteRows;
}(Operation);

// Creates rows


var OperationCreateRows = function (_Operation3) {
  inherits(OperationCreateRows, _Operation3);

  function OperationCreateRows(index, rowsData) {
    classCallCheck(this, OperationCreateRows);

    var _this5 = possibleConstructorReturn(this, (OperationCreateRows.__proto__ || Object.getPrototypeOf(OperationCreateRows)).call(this, 'CreateRows'));

    _this5.index = index;
    _this5.rowsData = rowsData;
    _this5.rowKeys = [];
    return _this5;
  }

  createClass(OperationCreateRows, [{
    key: 'apply',
    value: function apply(controller) {
      var _this6 = this;

      controller.update(controller.value.updateIn(['sheet', 'rows'], function (rows) {
        var newRows = List(_this6.rowsData.map(Row.create));
        _this6.rowsData = newRows.toJSON();
        _this6.rowKeys = newRows.map(function (row) {
          return row.key;
        });
        return rows.splice.apply(rows, [_this6.index, 0].concat(toConsumableArray(newRows.toArray())));
      }).update('sheet', function (sheet) {
        return Sheet.populateXY(sheet);
      }));

      controller.run('onRowsCreated', this.rowsData, this.index);
    }
  }, {
    key: 'invert',
    value: function invert() {
      return new OperationDeleteRows(this.rowKeys);
    }
  }]);
  return OperationCreateRows;
}(Operation);

var OPERATIONS = {
  OperationCellEdits: OperationCellEdits,
  OperationDeleteRows: OperationDeleteRows,
  OperationCreateRows: OperationCreateRows
};

function OperationsPlugin() {
  var addToUndoStack = true;

  return {
    onSetCellContent: function onSetCellContent(cell, property, content, controller, next) {
      controller.opSetCellContent(cell, property, content);
    },
    onClearSelectedCells: function onClearSelectedCells(controller, next) {
      controller.opClearCellsInSelection();
    },
    onEditCells: function onEditCells(property, edits, controller, next) {
      var op = new OperationCellEdits(property, edits);

      controller.applyOperation(op);
    },


    commands: {
      // Set the content of a cell.
      opSetCellContent: function opSetCellContent(controller, cell, property, content) {
        controller.run('onEditCells', property, [{ key: cell.key, from: cell[property], to: content }]);
      },


      // Clear the currently selected cells.
      opClearCellsInSelection: function opClearCellsInSelection(controller) {
        // TODO: Apply to displayValues too?
        var edits = [];
        controller.cellsInSelection(function (cell) {
          return edits.push({ key: cell.key, from: cell.editValue, to: undefined });
        });

        controller.run('onEditCells', 'editValue', edits);
      },


      // Create and insert a row.
      opInsertRow: function opInsertRow(controller, index, rowData) {
        controller.opInsertRows(index, [rowData]);
      },


      // Create and insert one or more rows.
      opInsertRows: function opInsertRows(controller, index, rowsData) {
        var op = new OperationCreateRows(index, rowsData);
        controller.applyOperation(op);
      },


      // Delete a row.
      opDeleteRow: function opDeleteRow(controller, row) {
        controller.opDeleteRows([row]);
      },


      // Delete multiple rows
      opDeleteRows: function opDeleteRows(controller, rows) {
        var op = new OperationDeleteRows(rows.map(function (row) {
          return row.key;
        }));
        controller.applyOperation(op);
      },
      withoutUndoHistory: function withoutUndoHistory(controller, fn) {
        var prevAddToUndoStack = addToUndoStack;
        addToUndoStack = false;

        try {
          fn();
        } finally {
          addToUndoStack = prevAddToUndoStack;
        }
      },
      createOperation: function createOperation(controller, name) {
        var OperationClass = OPERATIONS[name];
        if (!OperationClass) {
          throw new Error('Invalid operation name: ' + name);
        }

        for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          args[_key - 2] = arguments[_key];
        }

        return new (Function.prototype.bind.apply(OperationClass, [null].concat(toConsumableArray(args))))();
      },


      // Apply an operation by executing it.
      applyOperation: function applyOperation(controller, operation) {
        var undoing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        // When we are undoing don't record any new operations that are triggered
        // otherwise they pollute the undo stack.
        var setUndoing = false;
        if (undoing) {
          setUndoing = true;
          controller.globalUndoing = true;
        }

        operation.apply(controller);

        if (addToUndoStack) {
          controller.run('onOperation', {
            operation: operation,
            undoing: undoing || controller.globalUndoing
          });
        }

        if (setUndoing) {
          controller.globalUndoing = false;
        }
      }
    }
  };
}

var debug$1 = Debug('aha-sheet:undo');

/*
 * Undo/redo behavior.
 *
 * I considered using the immutable `value` object or `value.sheet` directly
 * for the undo stack. That would make for very simple code, but it has a
 * a problem when the sheet is backed by an API. It is difficult to track
 * when data needs to be synced with the API during undo and redo actions.
 *
 * Instead we track cell update operations directly so that each operation can
 * be undone or redone and the potential API actions are obvious, and scoped
 * to the specific cells that changed.
 */
function UndoPlugin() {
  var undoStack = [];
  var redoStack = [];

  // After undo or redo, change the selection to the affected cells.
  var selectOperationCells = function selectOperationCells(controller, operation) {
    if (!(operation instanceof OperationCellEdits)) {
      return;
    }
    var minX = Number.MAX_VALUE;
    var minY = Number.MAX_VALUE;
    var maxX = 0;
    var maxY = 0;
    operation.data.forEach(function (edit) {
      var cell = controller.getCellByKey(edit.key);
      if (cell.x < minX) {
        minX = cell.x;
      }
      if (cell.x > maxX) {
        maxX = cell.x;
      }
      if (cell.y < minY) {
        minY = cell.y;
      }
      if (cell.y > maxY) {
        maxY = cell.y;
      }
    });

    controller.selectRange(minX, minY, maxX, maxY);
  };

  var undo = function undo(controller) {
    if (undoStack.length > 0) {
      var op = undoStack.pop();
      debug$1('Pushing redo ' + JSON.stringify(op));
      redoStack.push(op);
      controller.applyOperation(op.invert(), true);

      selectOperationCells(controller, op);
    }
  };

  var redo = function redo(controller) {
    if (redoStack.length > 0) {
      var op = redoStack.pop();
      debug$1('Pushing undo ' + JSON.stringify(op));
      undoStack.push(op);
      controller.applyOperation(op, true);

      selectOperationCells(controller, op);
    }
  };

  return {
    onOperation: function onOperation(event, controller, next) {
      if (event.undoing) {
        return next();
      }
      debug$1('Pushing undo ' + JSON.stringify(event.operation));
      undoStack.push(event.operation);
    },
    onKeyDown: function onKeyDown(event, controller, next) {
      if (event.key === 'z' && (event.metaKey || event.ctrlKey)) {
        if (event.shiftKey) {
          debug$1('Redoing');
          redo(controller);
        } else {
          debug$1('Undoing');
          undo(controller);
        }
      }

      return next();
    }
  };
}

var CellErrorWrapper = function (_React$Component) {
  inherits(CellErrorWrapper, _React$Component);

  function CellErrorWrapper() {
    classCallCheck(this, CellErrorWrapper);
    return possibleConstructorReturn(this, (CellErrorWrapper.__proto__ || Object.getPrototypeOf(CellErrorWrapper)).apply(this, arguments));
  }

  createClass(CellErrorWrapper, [{
    key: 'render',
    value: function render() {
      var message = this.props.cell.getIn(['data', 'errorMessage']);

      if (message) {
        return React.createElement(
          'div',
          { className: 'aha-sheet-error-indicator', title: message },
          this.props.children
        );
      }

      return this.props.children;
    }
  }]);
  return CellErrorWrapper;
}(React.Component);

/*
 * Show error indicators on cells
 */
function IndicatorsPlugin() {
  return {
    onRenderCellContent: function onRenderCellContent(props, controller, next) {
      var cell = props.cell;

      return React.createElement(
        CellErrorWrapper,
        { cell: cell },
        next()
      );
    },


    commands: {
      isCellError: function isCellError(controller, cell) {
        return typeof cell.data.get('errorMessage') === 'string';
      },
      setCellError: function setCellError(controller, cell, message) {
        var eventInfo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

        controller.updateCellByKey(cell.key, 'data', cell.data.merge({ errorMessage: message }), eventInfo);
      }
    }
  };
}

/*
 * Track whether the sheet is focused
 */
function SheetFocusPlugin() {
  return {
    onFocus: function onFocus(event, controller, next) {
      controller.update(controller.value.setIn(['sheet', 'focused'], true));
      return next();
    },
    onBlur: function onBlur(event, controller, next) {
      controller.update(controller.value.setIn(['sheet', 'focused'], false));
      return next();
    },


    commands: {
      isSheetFocused: function isSheetFocused(controller) {
        return controller.value.sheet.focused;
      }
    }
  };
}

var debug$2 = Debug('aha-sheet:draggable-rows');

// TODO: This is still a kludge. It assumes a table structure exactly as the
// default renderer generates it. It needs to be made more generic.

/*
 * Allow rows to be dragged into different order.
 */
function DraggableRowsPlugin() {
  var dragging = false;
  var draggingRowKey = null;
  var draggingNode = null;
  var startX = void 0,
      startY = void 0,
      nodeOffsetX = void 0,
      nodeOffsetY = void 0;
  var draggingController = null;

  function startDragging(event, cell, controller) {
    draggingRowKey = controller.value.getIn(['sheet', 'rows', cell.y]).key;
    dragging = true;
    startX = event.pageX;
    startY = event.pageY;
    draggingController = controller;

    // Just a hack for now. How do we find the row node in a generic way?
    var node = event.target.parentNode;

    var nodeRect = node.getBoundingClientRect();
    nodeOffsetX = startX - (window.scrollX + nodeRect.left);
    nodeOffsetY = startY - (window.scrollY + nodeRect.top);

    // Use setTimeout to get redraw after clearing selection before drag
    // actually starts. Otherwise the selection looks very messed up.
    controller.clearSelection();
    setTimeout(function () {
      if (!dragging) return;
      var clonedNode = node.cloneNode(true);
      draggingNode = node.parentNode.appendChild(clonedNode);

      draggingNode.style.position = 'absolute';
      draggingNode.style.top = startY - nodeOffsetY + 'px';
      draggingNode.style.left = startX - nodeOffsetX + 'px';
      draggingNode.style.boxSizing = 'border-box';
      draggingNode.style.pointerEvents = 'none';
      draggingNode.style.display = 'none';
    });
  }

  function stopDragging() {
    if (draggingNode) {
      draggingNode.parentNode.removeChild(draggingNode);
    }
    draggingController.update(draggingController.value.update('sheet', function (sheet) {
      return Sheet.populateXY(sheet);
    }));

    dragging = false;
    draggingRowKey = null;
    draggingNode = null;
  }

  return {
    onMouseDown: function onMouseDown(event, cell, controller, next) {
      if (!cell.hasType('dragHandle')) {
        return next();
      }

      startDragging(event, cell, controller);
      // Register document level mouseup handler to catch mouseup outside element.
      document.addEventListener('mouseup', stopDragging);

      return next();
    },
    onMouseUp: function onMouseUp(event, cell, controller, next) {
      if (dragging) {
        stopDragging(controller);
        document.removeEventListener('mouseup', stopDragging);
      }
      return next();
    },
    onMouseMove: function onMouseMove(event, cell, controller, next) {
      if (!dragging || !draggingNode) {
        return next();
      }

      // Move the dragged node.
      draggingNode.style.top = event.pageY - nodeOffsetY + 'px';

      // Find the index of the node we are over
      var overNode = document.elementFromPoint(event.pageX - window.scrollX, event.pageY - window.scrollY);
      var newPos = Array.prototype.indexOf.call(overNode.parentNode.parentNode.childNodes, overNode.parentNode);

      // Check if the newPos can be dragged to.
      var overRow = controller.value.getIn(['sheet', 'rows', newPos]);
      if (!overRow.hasType('draggable')) {
        return;
      }

      var value = controller.value.updateIn(['sheet', 'rows'], function (rows) {
        var currentIndex = rows.findIndex(function (currentRow) {
          return currentRow.key === draggingRowKey;
        });
        debug$2(currentIndex);
        var row = rows.get(currentIndex);
        return rows.delete(currentIndex).insert(newPos, row);
      });

      controller.update(value);
    },
    onKeyDown: function onKeyDown(event, controller, next) {
      switch (event.key) {
        case 'Escape':
          // TODO: Abort
          break;
        default:
          return next();
      }
    }
  };
}

/*
 * Show a placeholder in empty cells
 */
function PlaceholderPlugin() {
  return {
    onRenderCellContent: function onRenderCellContent(props, controller, next) {
      var cell = props.cell;


      if (cell.hasType('placeholder') && (!cell.editValue || cell.editValue.length === 0)) {
        var placeholder = cell.getIn(['data', 'placeholder']);
        return React.createElement(
          'div',
          { className: 'aha-sheet-placeholder' },
          placeholder
        );
      } else {
        return next();
      }
    }
  };
}

/*
 * Commands for working with data
 */
function DataPlugin() {
  return {
    commands: {
      mergeValueData: function mergeValueData(controller, newValues) {
        controller.update(controller.value.mergeIn(['data'], newValues));
      }
    }
  };
}

var debugEvents = Debug('aha-sheet:events');

var Controller = function () {
  function Controller() {
    var _this = this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    classCallCheck(this, Controller);
    this.run = this.trackLastRun(this.runHandler);
    var _options$onChange = options.onChange,
        onChange = _options$onChange === undefined ? function () {} : _options$onChange,
        _options$onFocusSheet = options.onFocusSheet,
        onFocusSheet = _options$onFocusSheet === undefined ? function () {} : _options$onFocusSheet,
        _options$onBlurSheet = options.onBlurSheet,
        onBlurSheet = _options$onBlurSheet === undefined ? function () {} : _options$onBlurSheet,
        _options$plugins = options.plugins,
        plugins = _options$plugins === undefined ? [] : _options$plugins,
        _options$disabled = options.disabled,
        disabled = _options$disabled === undefined ? false : _options$disabled,
        _options$readOnly = options.readOnly,
        readOnly = _options$readOnly === undefined ? false : _options$readOnly,
        _options$value = options.value,
        value = _options$value === undefined ? Value.create() : _options$value;


    this.middleware = {};
    this.onChange = onChange;
    this.onFocusSheet = onFocusSheet;
    this.onBlurSheet = onBlurSheet;
    this.disabled = disabled;
    this.readOnly = readOnly;

    // Add the user plugins first.
    this.registerPlugin(plugins);
    // Then the default plugins.
    this.registerPlugin([SheetFocusPlugin(), InputPlugin(), HeaderPlugin(), DraggableRowsPlugin(), IndicatorsPlugin(), PlaceholderPlugin(), RenderPlugin(), SelectionPlugin(), ClipboardPlugin(), UndoPlugin(), OperationsPlugin(), DataPlugin()]);
    // Give each plugin a chance to run. Mark every cell as changed.
    this.update(value);
    this.value.sheet.rows.forEach(function (row) {
      row.cells.forEach(function (cell) {
        _this.run('onChangeCell', { cell: cell, initializing: true });
      });
    });
  }

  // Update the value and notify the view to update.
  // Return `true` if something actually changed.


  createClass(Controller, [{
    key: 'update',
    value: function update(newValue) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var oldValue = this.value;
      this.value = newValue;
      if (force || !newValue.equals(oldValue)) {
        this.onChange(oldValue, newValue);
        this.run('onChange', { oldValue: oldValue, newValue: newValue });
        return true;
      } else {
        return false;
      }
    }
  }, {
    key: 'setReadOnly',
    value: function setReadOnly() {
      var readOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this.readOnly !== readOnly) {
        this.readOnly = readOnly;
        this.update(this.value, true);
      }
    }
  }, {
    key: 'setDisabled',
    value: function setDisabled() {
      var disabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this.disabled !== disabled) {
        this.disabled = disabled;
        this.update(this.value, true);
      }
    }

    // Cell manipulation.

  }, {
    key: 'getCellByXY',
    value: function getCellByXY(x, y) {
      if (x < 0 || y < 0) {
        return null;
      }
      // To support colspan we need to consider each column index separately.
      var row = this.value.getIn(['sheet', 'rows', y]);
      if (!row) {
        return null;
      }

      var xOffset = 0;
      for (var index = 0; index < row.cells.size; index++) {
        var cell = row.cells.get(index);
        var cellWidth = cell.colspan || 1;
        if (x >= xOffset && x < xOffset + cellWidth) {
          return cell;
        }
        xOffset += cellWidth;
      }
      return null;
    }
  }, {
    key: 'getCellByKey',
    value: function getCellByKey(key) {
      return this.value.sheet.lookupCellByKey(key);
    }

    // provides an interface similar to Immutable updateIn(), to update a cell through an updater callback

  }, {
    key: 'updateCell',
    value: function updateCell(cell, updater) {
      var eventInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.updateCells([cell], updater, eventInfo);
    }
  }, {
    key: 'updateCells',
    value: function updateCells(cells, updater) {
      var _this2 = this;

      var eventInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var newValue = cells.reduce(function (value, cell) {
        return value.updateCell(cell, function (_cell) {
          var newCell = updater(_cell);

          if (cell.key !== newCell.key) {
            throw new Error('Cell.key cannot be modified.');
          }

          return newCell;
        });
      }, this.value);

      if (this.update(newValue)) {
        cells.forEach(function (oldCell) {
          // get updated cell data
          var newCell = _this2.getCellByKey(oldCell.key);

          _this2.run('onChangeCell', _extends({}, eventInfo, {
            cell: newCell
          }));
        });
      }
    }
  }, {
    key: 'updateCellByKey',
    value: function updateCellByKey(key, property, value) {
      var eventInfo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      var cell = this.getCellByKey(key);
      this.updateCell(cell, function (_cell) {
        if (property === 'data') {
          value = Data.create(value);
        }
        return _cell.set(property, value);
      }, eventInfo);
    }
  }, {
    key: 'getRowByIndex',
    value: function getRowByIndex(y) {
      return this.value.sheet.rows.get(y);
    }
  }, {
    key: 'getRowByKey',
    value: function getRowByKey(key) {
      return this.value.sheet.lookupRowByKey(key);
    }
  }, {
    key: 'findCell',
    value: function findCell(matcher) {
      return this.value.sheet.findCell(matcher);
    }
  }, {
    key: 'filterCells',
    value: function filterCells(matcher) {
      return this.value.sheet.filterCells(matcher);
    }
  }, {
    key: 'findRow',
    value: function findRow(matcher) {
      return this.value.sheet.findRow(matcher);
    }
  }, {
    key: 'filterRows',
    value: function filterRows(matcher) {
      return this.value.sheet.filterRows(matcher);
    }

    // Editing

  }, {
    key: 'canEdit',
    value: function canEdit() {
      return !this.disabled && !this.readOnly;
    }
  }, {
    key: 'canEditCell',
    value: function canEditCell(cell) {
      return this.canEdit() && !cell.isReadOnly();
    }
  }, {
    key: 'startEditing',
    value: function startEditing(cell) {
      this.update(this.value.setIn(['editingX'], cell.x).setIn(['editingY'], cell.y));
    }
  }, {
    key: 'endEditing',
    value: function endEditing() {
      this.update(this.value.setIn(['editingX'], undefined).setIn(['editingY'], undefined));
    }
  }, {
    key: 'isCellEditing',
    value: function isCellEditing(cell) {
      return this.value.isCellEditing(cell);
    }

    /*
     * Plugin handling.
     */

    // Track calls to run that re-enter and send a synthetic event at the end
    // of a sequence. This allows plugins to collect data that happens within
    // the same original event, e.g. edits to multiple cells at once.

  }, {
    key: 'trackLastRun',
    value: function trackLastRun(runFunc) {
      return function () {
        var originalRun = true;
        if (this.runningEvent) {
          originalRun = false;
        } else {
          this.runningEvent = true;
        }

        var result = runFunc.apply(this, arguments);

        if (originalRun) {
          this.runningEvent = false;
          this.runHandler('onEventsComplete', {});
        }

        return result;
      };
    }

    // Run through the plugin stack for the specified 'eventHandler'.

  }, {
    key: 'runHandler',
    value: function runHandler(eventHandler) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      debugEvents('Event ' + eventHandler + ' for sheet');

      var middleware = this.middleware;

      var controller = this;
      var fns = (middleware[eventHandler] || []).slice();
      var i = 0;
      var handled = true;

      // If the last argument is a function then this is used as the default
      // next() function, i.e. the default return value of the runHandler.
      if (typeof args[args.length - 1] === 'function') {
        fns.push(args.pop());
      }

      function next() {
        var fn = fns[i++];
        if (!fn) {
          handled = false;
          return;
        }

        for (var _len2 = arguments.length, overrides = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          overrides[_key2] = arguments[_key2];
        }

        if (overrides.length) {
          args = overrides;
        }

        var ret = fn.apply(undefined, toConsumableArray(args).concat([controller, next, stop]));
        return ret;
      }

      function stop() {
        var stopPropagation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

        handled = stopPropagation;
      }

      var returnValue = next();

      if (handled && args[0] && args[0].preventDefault) {
        args[0].preventDefault();
        args[0].stopPropagation();
      }
      return returnValue;
    }
  }, {
    key: 'registerCommand',


    // Register a command.
    value: function registerCommand(command, fn) {
      var _this3 = this;

      // Already registered?
      if (command in this && this[command].__command) {
        return this;
      }

      invariant(!(command in this), 'You cannot register a `' + command + '` command because it would overwrite an existing property.');

      var method = function method() {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        return fn.apply(undefined, [_this3].concat(args));
      };
      this[command] = method;
      method.__command = true;
    }

    // Register a plugin or an array of plugins.

  }, {
    key: 'registerPlugin',
    value: function registerPlugin(plugin_or_array) {
      var _this4 = this;

      if (Array.isArray(plugin_or_array)) {
        plugin_or_array.forEach(function (p) {
          return _this4.registerPlugin(p);
        });
        return;
      }

      var commands = plugin_or_array.commands,
          eventHandlers = objectWithoutProperties(plugin_or_array, ['commands']);


      if (commands) {
        for (var command in commands) {
          this.registerCommand(command, commands[command]);
        }
      }

      for (var key in eventHandlers) {
        var fn = eventHandlers[key];
        var middleware = this.middleware[key] = this.middleware[key] || [];
        middleware.push(fn);
      }
    }
  }]);
  return Controller;
}();

/*
 * These events are captured by specific cells.
 */
var CELL_EVENTS = ['onMouseDown', 'onMouseUp', 'onMouseMove', 'onClick', 'onDoubleClick', 'onContextMenu', 'onDragEnd', 'onDragEnter', 'onDragExit', 'onDragLeave', 'onDragOver', 'onDragStart', 'onDrop'];

/*
 * These events are not cell specific, rather they respond to the overall
 * state of the sheet, e.g. which cell is focused or selected.
 */
var SHEET_EVENTS = ['onKeyDown', 'onKeyUp', 'onBlur', 'onFocus'];

var CellComponent = function (_React$PureComponent) {
  inherits(CellComponent, _React$PureComponent);

  function CellComponent(props) {
    classCallCheck(this, CellComponent);

    var _this = possibleConstructorReturn(this, (CellComponent.__proto__ || Object.getPrototypeOf(CellComponent)).call(this, props));

    _this.handlers = CELL_EVENTS.reduce(function (obj, handler) {
      obj[handler] = function (event) {
        if (!_this.props.controller.disabled) {
          _this.onEvent(handler, event);
        }
      };
      return obj;
    }, {});

    _this.cellRef = React.createRef();
    _this.childRef = React.createRef();
    return _this;
  }

  createClass(CellComponent, [{
    key: 'onEvent',
    value: function onEvent(handler, event) {
      this.props.controller.run(handler, event, this.props.cell);
    }
  }, {
    key: 'render',
    value: function render() {
      var controller = this.props.controller;

      var props = _extends({}, this.props, {
        cellRef: this.cellRef,
        childRef: this.childRef,
        handlers: this.handlers
      });

      props.children = controller.run('onRenderCellContent', props);
      var element = controller.run('onRenderCell', props);

      return element;
    }
  }]);
  return CellComponent;
}(React.PureComponent);

CellComponent.propTypes = {
  value: PropTypes.object
};

var RowComponent = function (_React$Component) {
  inherits(RowComponent, _React$Component);

  function RowComponent() {
    classCallCheck(this, RowComponent);
    return possibleConstructorReturn(this, (RowComponent.__proto__ || Object.getPrototypeOf(RowComponent)).apply(this, arguments));
  }

  createClass(RowComponent, [{
    key: 'renderCells',
    value: function renderCells(controller) {
      var _this2 = this;

      return this.props.row.cells.toArray().map(function (cell, i) {
        var props = {
          cell: cell,
          row: _this2.props.row,
          sheetRef: _this2.props.sheetRef,
          controller: controller,
          selected: controller.value.selection.isCellSelected(controller, cell),
          selectedSide: controller.value.selection.selectionSide(controller, cell),
          focused: controller.value.selection.isCellFocused(cell),
          editing: controller.value.isCellEditing(cell)
        };

        return React.createElement(CellComponent, _extends({ key: i }, props));
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var props = {
        row: this.props.row,
        sheetRef: this.props.sheetRef,
        children: this.renderCells(this.props.controller),
        controller: this.props.controller
      };
      var element = this.props.controller.run('onRenderRow', props);

      return element;
    }
  }]);
  return RowComponent;
}(React.Component);

RowComponent.propTypes = {
  value: PropTypes.object
};

var AhaSheet = function (_React$Component) {
  inherits(AhaSheet, _React$Component);

  function AhaSheet(props) {
    classCallCheck(this, AhaSheet);

    var _this = possibleConstructorReturn(this, (AhaSheet.__proto__ || Object.getPrototypeOf(AhaSheet)).call(this, props));

    _this.controller = null;
    _this.handlers = SHEET_EVENTS.reduce(function (obj, handler) {
      obj[handler] = function (event) {
        if (!_this.controller.disabled) {
          _this.onEvent(handler, event);
        }
      };
      return obj;
    }, {});

    _this.controller = new Controller({
      value: props.value,
      onChange: _this.onChange.bind(_this),
      onFocusSheet: _this.onFocusSheet.bind(_this),
      onBlurSheet: _this.onBlurSheet.bind(_this),
      plugins: props.plugins,
      disabled: props.disabled,
      readOnly: props.readOnly
    });
    _this.sheetRef = React.createRef();
    _this.state = { value: _this.controller.value };
    return _this;
  }

  createClass(AhaSheet, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (prevProps.readOnly !== this.props.readOnly) {
        this.controller.setReadOnly(this.props.readOnly);
      }

      if (prevProps.disabled !== this.props.disabled) {
        this.controller.setDisabled(this.props.disabled);
      }
    }
  }, {
    key: 'onFocusSheet',
    value: function onFocusSheet() {
      if (this.sheetRef.current) this.sheetRef.current.focus();
    }
  }, {
    key: 'onBlurSheet',
    value: function onBlurSheet() {
      if (this.sheetRef.current) this.sheetRef.current.blur();
    }
  }, {
    key: 'onChange',
    value: function onChange(oldValue, newValue) {
      if (!this.state) {
        this.state = { value: newValue };
      } else if (this.state.value !== newValue) {
        this.setState({ value: newValue });
      }
      if (this.props.onChange) {
        this.props.onChange(newValue);
      }
    }
  }, {
    key: 'onEvent',
    value: function onEvent(handler, event) {
      this.controller.run(handler, event);
    }
  }, {
    key: 'renderRows',
    value: function renderRows() {
      var _this2 = this;

      return this.state.value.sheet.rows.toArray().map(function (child, i) {
        return React.createElement(RowComponent, {
          key: i,
          row: child,
          controller: _this2.controller,
          sheetRef: _this2.sheetRef
        });
      });
    }
  }, {
    key: 'clipboardProxy',
    value: function clipboardProxy(event, handler) {
      if (this.sheetRef.current === document.activeElement) {
        this.onEvent(handler, event);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this3 = this;

      this.onEvent('onMount', this);

      // Workaround for https://bugs.chromium.org/p/chromium/issues/detail?id=754593#c1
      // by listening on the document and turning into a sheet event.
      this.onCopyProxy = function (event) {
        return _this3.clipboardProxy(event, 'onCopy');
      };
      document.addEventListener('copy', this.onCopyProxy);
      this.onCutProxy = function (event) {
        return _this3.clipboardProxy(event, 'onCut');
      };
      document.addEventListener('cut', this.onCutProxy);
      this.onPasteProxy = function (event) {
        return _this3.clipboardProxy(event, 'onPaste');
      };
      document.addEventListener('paste', this.onPasteProxy);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.onEvent('onUnmount', this);

      document.removeEventListener('copy', this.onCopyProxy);
      document.removeEventListener('cut', this.onCutProxy);
      document.removeEventListener('paste', this.onPasteProxy);
    }
  }, {
    key: 'render',
    value: function render() {
      var props = {
        sheet: this.state.value.sheet,
        sheetRef: this.sheetRef,
        children: this.renderRows(),
        controller: this.props.controller
      };
      var element = this.controller.run('onRenderSheet', props);

      var classes = classNames('aha-sheet', {
        focused: this.controller.value.sheet.focused
      });

      return React.createElement(
        'div',
        _extends({}, this.handlers, {
          ref: this.sheetRef,
          tabIndex: '0',
          className: classes
        }),
        element
      );
    }
  }]);
  return AhaSheet;
}(React.Component);

AhaSheet.propTypes = {
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  value: PropTypes.object
};

function ButtonPlugin(buttonFunctions) {
  return {
    onClick: function onClick(event, cell, controller, next) {
      if (!cell.types.includes('button')) {
        return next();
      }

      buttonFunctions[cell.data.get('buttonFunc')].call(null, event, cell, controller, next);
    }
  };
}

export { AhaSheet, Value, Sheet, Row, Cell, CellErrorWrapper, ButtonPlugin, PlaceholderPlugin, InputPlugin };
